import { useQuery } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import type { MemberAttendanceQueryParams } from "@membentry/shared-types";
import { myAttendanceQueryKey } from "./queryKeys";

/**
 * Fetch the authenticated member's attendance history for a club.
 *
 * Wraps `GET /clubs/{clubId}/members/me/entries`.
 */
export const useMyAttendanceQuery = (
  client: AxiosInstance,
  params: MemberAttendanceQueryParams,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: myAttendanceQueryKey(params),
    queryFn: async () => {
      const { getMyAttendance } = await import("@membentry/shared-api");
      return getMyAttendance(client, params);
    },
    enabled: options?.enabled !== false && params.clubId > 0,
  });
};
